import { render, staticRenderFns } from "./the-cookie-banner.vue?vue&type=template&id=1009960c&scoped=true&"
import script from "./the-cookie-banner.vue?vue&type=script&lang=js&"
export * from "./the-cookie-banner.vue?vue&type=script&lang=js&"
import style0 from "./the-cookie-banner.vue?vue&type=style&index=0&id=1009960c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009960c",
  null
  
)

export default component.exports